export interface TimeSettingsPreset {
  id: string;
  name: string;
  description: string;
  icon: string;
  slope: number;
  intercept: number;
  window: number;
  onceOffProcessingTime: number;
  processingTimes: { seatType: string; processingTimeSeconds: number }[];
}

export const TIME_SETTINGS_PRESETS: TimeSettingsPreset[] = [
  {
    id: 'ride-hailing',
    name: 'Ride Hailing',
    description: 'Fast response times for on-demand rides',
    icon: 'DirectionsCar',
    slope: 1.7,
    intercept: 600,
    window: 900,
    onceOffProcessingTime: 15,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 30 },
      { seatType: 'wheelchair', processingTimeSeconds: 300 }
    ]
  },
  {
    id: 'paratransit',
    name: 'Paratransit',
    description: 'Extended times for accessibility services',
    icon: 'Accessible',
    slope: 2.5,
    intercept: 1800,
    window: 1800,
    onceOffProcessingTime: 30,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 45 },
      { seatType: 'wheelchair', processingTimeSeconds: 300 }
    ]
  },
  {
    id: 'rural',
    name: 'Rural',
    description: 'Longer windows for remote area services',
    icon: 'Landscape',
    slope: 2.5,
    intercept: 1200,
    window: 1800,
    onceOffProcessingTime: 20,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 35 },
      { seatType: 'wheelchair', processingTimeSeconds: 300 }
    ]
  },
  {
    id: 'manual',
    name: 'Manual',
    description: 'Customize all settings manually',
    icon: 'Settings',
    slope: 1.7,
    intercept: 600,
    window: 900,
    onceOffProcessingTime: 15,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 30 },
      { seatType: 'wheelchair', processingTimeSeconds: 300 }
    ]
  }
];

export function getPresetById(id: string): TimeSettingsPreset | undefined {
  return TIME_SETTINGS_PRESETS.find(preset => preset.id === id);
}

export function detectCurrentPreset(
  slope: number,
  intercept: number,
  window: number,
  onceOffProcessingTime: number,
  processingTimes: { seatType: string; processingTimeSeconds: number }[]
): string {
  // Check if settings match any preset exactly
  for (const preset of TIME_SETTINGS_PRESETS) {
    if (preset.id === 'manual') continue;
    
    if (
      Math.abs(slope - preset.slope) < 0.1 &&
      Math.abs(intercept - preset.intercept) < 10 &&
      Math.abs(window - preset.window) < 10 &&
      Math.abs(onceOffProcessingTime - preset.onceOffProcessingTime) < 5
    ) {
      // Check if processing times match
      const processingTimesMatch = preset.processingTimes.every((pt, index) => {
        const currentPT = processingTimes[index];
        return currentPT && 
               currentPT.seatType === pt.seatType && 
               Math.abs(currentPT.processingTimeSeconds - pt.processingTimeSeconds) < 5;
      });
      
      if (processingTimesMatch) {
        return preset.id;
      }
    }
  }
  
  return 'manual';
} 